export default "__VITE_ASSET__$Px_RKt7__"